import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient, { TransferDeviceDataParams } from "../../../api/admin";

const useTransferDeviceDataMutation = (clockId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["transferDeviceData", clockId],
    mutationFn: (params: TransferDeviceDataParams) =>
      adminApiClient.transferDeviceData(clockId, params),
    onSuccess: (result, { targetClockId }) => {
      // Only invalidate once the transfer actually ran — a
      // confirmation_required response left both clocks untouched.
      if (result.status !== "success") return;
      queryClient.invalidateQueries({ queryKey: ["deviceGifts", clockId] });
      queryClient.invalidateQueries({
        queryKey: ["deviceGifts", targetClockId],
      });
    },
  });
};

export default useTransferDeviceDataMutation;
